<template>
  <div
    :class="{'nav-open': $sidebar.showSidebar}"
    class="app"
  >
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {

    }
  },
  mounted () {

  }
}
</script>
<style lang="scss">
.app {
  font-size: 14px;
  /*overflow-y: auto;*/
  /*background: #f2f2f2!important;*/
}
.vue-notifyjs.notifications {
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  /*去掉手机端的边框线*/
  .app .layui-tab-card {
    border: none;
    box-shadow: none;
  }
}
 
</style>
